import api from '../../utils/axios';

export const packageService = {
    // Get all packages for the logged-in agent
    getPackages: async (params = {}) => {
        const response = await api.get('/packages', { params });
        return response.data;
    },

    // Get a single package by ID
    getPackageById: async (id) => {
        const response = await api.get(`/packages/${id}`);
        return response.data;
    },

    // Create a new package
    createPackage: async (data) => {
        const response = await api.post('/packages', data);
        return response.data;
    },

    // Update a package
    updatePackage: async (id, data) => {
        const response = await api.put(`/packages/${id}`, data);
        return response.data;
    },

    // Delete a package (soft delete)
    deletePackage: async (id) => {
        const response = await api.delete(`/packages/${id}`);
        return response.data;
    },

    // Toggle publish/unpublish
    toggleStatus: async (id, status) => {
        const response = await api.patch(`/packages/${id}/status`, { status });
        return response.data;
    },

    // Upload single file/attachment
    uploadFile: async (formData) => {
        const response = await api.post('/upload/single', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
};
